import { render } from "./VerifyEmailOk.vue?vue&type=template&id=65e20fc2&scoped=true&ts=true"
import script from "./VerifyEmailOk.vue?vue&type=script&lang=ts"
export * from "./VerifyEmailOk.vue?vue&type=script&lang=ts"

import "./VerifyEmailOk.vue?vue&type=style&index=0&id=65e20fc2&scoped=true&lang=css"

import exportComponent from "/Users/pontustengroth/Desktop/git/shipd/apps/shipd-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65e20fc2"]])

export default __exports__